import React, { useState } from "react";
import { get } from "../api";
import { t } from "../i18n";
import { useStore } from "../store";
import { Avatar, Empty, Link, Spinner, cx, useAsync } from "../ui";

const GAMES = ["", "jackaroo", "ludo", "domino", "carrom", "billiards", "memory"];

export function Leaderboard() {
  const me = useStore((s) => s.me)!;
  const [period, setPeriod] = useState<"weekly" | "monthly" | "all">("weekly");
  const [game, setGame] = useState("");
  const data = useAsync(() => get(`/api/leaderboard?period=${period}${game ? `&game=${game}` : ""}`), [period, game]);
  return (
    <div className="leaderboard">
      <h1>{t.leaderboard}</h1>
      <div className="row wrap">
        <div className="segmented" role="radiogroup">
          {(["weekly", "monthly", "all"] as const).map((p) => (
            <button key={p} role="radio" aria-checked={period === p} className={period === p ? "is-on" : ""} onClick={() => setPeriod(p)}>
              {p === "weekly" ? t.weekly : p === "monthly" ? t.monthly : t.allTime}
            </button>
          ))}
        </div>
        <select value={game} onChange={(e) => setGame(e.target.value)} aria-label={t.games}>
          {GAMES.map((g) => <option key={g} value={g}>{g ? t.game[g] : t.allGames}</option>)}
        </select>
      </div>
      {data.loading && !data.data ? (
        <Spinner />
      ) : data.data?.rows?.length ? (
        <ol className="rank rank-big">
          {data.data.rows.map((r: any, i: number) => (
            <li key={r.user_id} className={cx(r.user_id === me.id && "is-me", i < 3 && `podium-${i + 1}`)}>
              <span className="rank-n">{i + 1}</span>
              <Avatar name={r.display_name} url={r.avatar_url} size={36} />
              <Link to={`/u/${r.username}`} className="grow">{r.display_name}</Link>
              <small className="muted">{t.level} {r.level}</small>
              <bdi className="rank-pts">{r.points}</bdi>
            </li>
          ))}
        </ol>
      ) : (
        <Empty>{t.noRanking}</Empty>
      )}
    </div>
  );
}
